import React from 'react'
import i18next from 'i18next'

import { PostalCodeForm } from 'app/delivery-area/components/postal-code-form'

import './HeroHeader.css'

const HeroHeader = () => (
  <header className="hero-header" role="banner">
    <div className="hero-header__wrapper">
      <div className="hero-header__content">
        <h1 className="hero-header__title">
          {i18next.t('header_section.title')}
        </h1>
        <p className="hero-header__description">
          {i18next.t('header_section.description')}
        </p>
        <PostalCodeForm />
      </div>
    </div>
  </header>
)

export { HeroHeader }
